import {
  FileText, Folder, BookOpen, Star, Heart, Zap, Code, Briefcase,
  Home, Music, Camera, Coffee, Globe, Lock, Tag, Bookmark,
  Map, MessageCircle, Calendar, Clock, User, Lightbulb,
  Target, Award, ShoppingBag, Plane, Palette, Dumbbell, Leaf, Brain,
} from 'lucide-react';
import i18n from '../i18n';

const ICON_COMPONENTS = {
  FileText, Folder, BookOpen, Star, Heart, Zap, Code, Briefcase,
  Home, Music, Camera, Coffee, Globe, Lock, Tag, Bookmark,
  Map, MessageCircle, Calendar, Clock, User, Lightbulb,
  Target, Award, ShoppingBag, Plane, Palette, Dumbbell, Leaf, Brain,
};

// label her erişimde i18n.t() ile hesaplanır ki dil değişince güncel kalsın
export const CATEGORY_ICONS = Object.keys(ICON_COMPONENTS).map((id) => {
  const item = { id, Icon: ICON_COMPONENTS[id] };
  Object.defineProperty(item, 'label', {
    enumerable: true,
    get: () => i18n.t(`notes:categoryIcons.${id}`),
  });
  return item;
});

/** İkon adından React bileşeni döndürür. Bilinmiyorsa Tag döner. */
export const getCategoryIcon = (iconId) => {
  if (!iconId) return Tag;
  const found = CATEGORY_ICONS.find((i) => i.id === iconId);
  return found ? found.Icon : Tag;
};
